import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-show-map-button',
    templateUrl: './show-map-button.component.html',
    styleUrls: ['./show-map-button.component.scss'],
    standalone: false,
})
export class ShowMapButtonComponent {
}
